import { render, staticRenderFns } from "./OptionsPreview.vue?vue&type=template&id=da7dcdca&scoped=true"
import script from "./OptionsPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./OptionsPreview.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./OptionsPreview.vue?vue&type=style&index=0&id=da7dcdca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da7dcdca",
  null
  
)

export default component.exports